"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.default = void 0;
var _database = _interopRequireDefault(require("./database.js"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// via https://unpkg.com/browse/emojibase-data@6.0.0/meta/groups.json
var allGroups = [[-1, '✨', 'custom'], [0, '😀', 'smileys-emotion'], [1, '👋', 'people-body'], [3, '🐱', 'animals-nature'], [4, '🍎', 'food-drink'], [5, '🏠️', 'travel-places'], [6, '⚽', 'activities'], [7, '📝', 'objects'], [8, '⛔️', 'symbols'], [9, '🏁', 'flags']].map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 3),
    id = _ref2[0],
    emoji = _ref2[1],
    name = _ref2[2];
  return {
    id: id,
    emoji: emoji,
    name: name
  };
});
var groups = allGroups.slice(1);
var MIN_SEARCH_TEXT_LENGTH = 2;
var NUM_SKIN_TONES = 6;

/* istanbul ignore next */
var rIC = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

// check for ZWJ (zero width joiner) character
function hasZwj(emoji) {
  return emoji.unicode.includes("\u200D");
}

// Find one good representative emoji from each version to test by checking its color.
// Ideally it should have color in the center. For some inspiration, see:
// https://about.gitlab.com/blog/2018/05/30/journey-in-native-unicode-emoji/
//
// Note that for certain versions (12.1, 13.1), there is no point in testing them explicitly, because
// all the emoji from this version are compound-emoji from previous versions. So they would pass a color
// test, even in browsers that display them as double emoji. (E.g. "face in clouds" might render as
// "face without mouth" plus "fog".) These emoji can only be filtered using the width test,
// which happens in checkZwjSupport.js.
var versionsAndTestEmoji = {
  '🫩': 16,
  // face with bags under eyes
  '🫨': 15.1,
  // shaking head, technically from v15 but see note above
  '🫠': 14,
  '🥲': 13.1,
  // smiling face with tear, technically from v13 but see note above
  '🥻': 12.1,
  // sari, technically from v12 but see note above
  '🥰': 11,
  '🤩': 5,
  '👱‍♀️': 4,
  '🤣': 3,
  '👁️‍🗨️': 2,
  '😀': 1,
  '😐️': 0.7,
  '😃': 0.6
};
var TIMEOUT_BEFORE_LOADING_MESSAGE = 1000; // 1 second
var DEFAULT_SKIN_TONE_EMOJI = '🖐️';
var DEFAULT_NUM_COLUMNS = 8;

// Based on https://fivethirtyeight.com/features/the-100-most-used-emojis/ and
// https://blog.emojipedia.org/facebook-reveals-most-and-least-used-emojis/ with
// a bit of my own curation. (E.g. avoid the "OK" gesture because of connotations:
// https://emojipedia.org/ok-hand/)
var MOST_COMMONLY_USED_EMOJI = ['😊', '😒', '❤️', '👍️', '😍', '😂', '😭', '☺️', '😔', '😩', '😏', '💕', '🙌', '😘'];

// It's important to list Twemoji Mozilla before everything else, because Mozilla bundles their
// own font on some platforms (notably Windows and Linux as of this writing). Typically, Mozilla
// updates faster than the underlying OS, and we don't want to render older emoji in one font and
// newer emoji in another font:
// https://github.com/nolanlawson/emoji-picker-element/pull/268#issuecomment-1073347283
var FONT_FAMILY = '"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol",' + '"Noto Color Emoji","EmojiOne Color","Android Emoji",sans-serif';

/* istanbul ignore next */
var DEFAULT_CATEGORY_SORTING = function DEFAULT_CATEGORY_SORTING(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
};

// Test if an emoji is supported by rendering it to canvas and checking that the color is not black
// See https://about.gitlab.com/blog/2018/05/30/journey-in-native-unicode-emoji/
// and https://www.npmjs.com/package/if-emoji for inspiration
// This implementation is largely borrowed from if-emoji, adding the font-family

var getTextFeature = function getTextFeature(text, color) {
  var canvas = document.createElement('canvas');
  canvas.width = canvas.height = 1;
  var ctx = canvas.getContext('2d', {
    // Improves the performance of `getImageData()`
    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/getContextAttributes#willreadfrequently
    willReadFrequently: true
  });
  ctx.textBaseline = 'top';
  ctx.font = "100px ".concat(FONT_FAMILY);
  ctx.fillStyle = color;
  ctx.scale(0.01, 0.01);
  ctx.fillText(text, 0, 0);
  return ctx.getImageData(0, 0, 1, 1).data;
};
var compareFeatures = function compareFeatures(feature1, feature2) {
  var feature1Str = _toConsumableArray(feature1).join(',');
  var feature2Str = _toConsumableArray(feature2).join(',');
  // This is RGBA, so for 0,0,0, we are checking that the first RGB is not all zeroes.
  // Most of the time when unsupported this is 0,0,0,0, but on Chrome on Mac it is
  // 0,0,0,61 - there is a transparency here.
  return feature1Str === feature2Str && !feature1Str.startsWith('0,0,0,');
};
function testColorEmojiSupported(text) {
  // Render white and black and then compare them to each other and ensure they're the same
  // color, and neither one is black. This shows that the emoji was rendered in color.
  var feature1 = getTextFeature(text, '#000');
  var feature2 = getTextFeature(text, '#fff');
  return feature1 && feature2 && compareFeatures(feature1, feature2);
}

// rather than check every emoji ever, which would be expensive, just check some representatives from the
// different emoji releases to determine what the font supports

function determineEmojiSupportLevel() {
  var entries = Object.entries(versionsAndTestEmoji);
  try {
    // start with latest emoji and work backwards
    for (var _i = 0, _entries = entries; _i < _entries.length; _i++) {
      var _ref3 = _entries[_i];
      var _ref4 = _slicedToArray(_ref3, 2);
      var emoji = _ref4[0];
      var version = _ref4[1];
      if (testColorEmojiSupported(emoji)) {
        return version;
      }
    }
  } catch (e) {// canvas error
  } finally {}
  // In case of an error, be generous and just assume all emoji are supported (e.g. for canvas errors
  // due to anti-fingerprinting add-ons). Better to show some gray boxes than nothing at all.
  return entries[0][1]; // first one in the list is the most recent version
}

// Check which emojis we know for sure aren't supported, based on Unicode version level
var promise;
var detectEmojiSupportLevel = function detectEmojiSupportLevel() {
  if (!promise) {
    // Delay so it can run while the IDB database is being created by the browser (on another thread).
    // This helps especially with first load – we want to start pre-populating the database on the main thread,
    // and then wait for IDB to commit everything, and while waiting we run this check.
    promise = new Promise(function (resolve) {
      return rIC(function () {
        return resolve(determineEmojiSupportLevel()) // delay so ideally this can run while IDB is first populating
        ;
      });
    });
  }
  return promise;
};
// determine which emojis containing ZWJ (zero width joiner) characters
// are supported (rendered as one glyph) rather than unsupported (rendered as two or more glyphs)
var supportedZwjEmojis = new Map();
var VARIATION_SELECTOR = "\uFE0F";
var SKINTONE_MODIFIER = "\uD83C";
var ZWJ = "\u200D";
var LIGHT_SKIN_TONE = 0x1F3FB;
var LIGHT_SKIN_TONE_MODIFIER = 0xdffb;

// TODO: this is a naive implementation, we can improve it later
// It's only used for the skintone picker, so as long as people don't customize with
// really exotic emoji then it should work fine
function applySkinTone(str, skinTone) {
  if (skinTone === 0) {
    return str;
  }
  var zwjIndex = str.indexOf(ZWJ);
  if (zwjIndex !== -1) {
    return str.substring(0, zwjIndex) + String.fromCodePoint(LIGHT_SKIN_TONE + skinTone - 1) + str.substring(zwjIndex);
  }
  if (str.endsWith(VARIATION_SELECTOR)) {
    str = str.substring(0, str.length - 1);
  }
  return str + SKINTONE_MODIFIER + String.fromCodePoint(LIGHT_SKIN_TONE_MODIFIER + skinTone - 1);
}
function halt(event) {
  event.preventDefault();
  event.stopPropagation();
}

// Implementation left/right or up/down navigation, circling back when you
// reach the start/end of the list
function incrementOrDecrement(decrement, val, arr) {
  val += decrement ? -1 : 1;
  if (val < 0) {
    val = arr.length - 1;
  } else if (val >= arr.length) {
    val = 0;
  }
  return val;
}

// like lodash's uniqBy but much smaller
function uniqBy(arr, func) {
  var set = new Set();
  var res = [];
  var _iterator = _createForOfIteratorHelper(arr),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      var key = func(item);
      if (!set.has(key)) {
        set.add(key);
        res.push(item);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return res;
}

// We don't need all the data on every emoji, and there are specific things we need
// for the UI, so build a "view model" from the emoji object we got from the database

function summarizeEmojisForUI(emojis, emojiSupportLevel) {
  var toSimpleSkinsMap = function toSimpleSkinsMap(skins) {
    var res = {};
    var _iterator2 = _createForOfIteratorHelper(skins),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var skin = _step2.value;
        // ignore arrays like [1, 2] with multiple skin tones
        // also ignore variants that are in an unsupported emoji version
        // (these do exist - variants from a different version than their base emoji)
        if (typeof skin.tone === 'number' && skin.version <= emojiSupportLevel) {
          res[skin.tone] = skin.unicode;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return res;
  };
  return emojis.map(function (_ref5) {
    var unicode = _ref5.unicode,
      skins = _ref5.skins,
      shortcodes = _ref5.shortcodes,
      url = _ref5.url,
      name = _ref5.name,
      category = _ref5.category,
      annotation = _ref5.annotation;
    return {
      unicode: unicode,
      name: name,
      shortcodes: shortcodes,
      url: url,
      category: category,
      annotation: annotation,
      id: unicode || name,
      skins: skins && toSimpleSkinsMap(skins)
    };
  });
}

// import rAF from one place so that the bundle size is a bit smaller
var rAF = requestAnimationFrame;

// "Svelte action"-like utility to detect layout changes via ResizeObserver.
// If ResizeObserver is unsupported, we just use rAF once and don't bother to update.

var resizeObserverSupported = typeof ResizeObserver === 'function';
function resizeObserverAction(node, abortSignal, onUpdate) {
  var resizeObserver;
  if (resizeObserverSupported) {
    resizeObserver = new ResizeObserver(onUpdate);
    resizeObserver.observe(node);
  } else {
    // just run once, don't bother trying to track it
    rAF(onUpdate);
  }

  // cleanup function (called on destroy)
  abortSignal.addEventListener('abort', function () {
    if (resizeObserver) {
      resizeObserver.disconnect();
    }
  });
}

// get the width of the text inside of a DOM node, via https://stackoverflow.com/a/59525891/680742
function calculateTextWidth(node) {
  // skip running this in jest/vitest because we don't need to check for emoji support in that environment
  /* istanbul ignore else */
  {
    var range = document.createRange();
    range.selectNode(node.firstChild);
    return range.getBoundingClientRect().width;
  }
}
var baselineEmojiWidth;

/**
 * Check if the given emojis containing ZWJ characters are supported by the current browser (don't render
 * as double characters) and return true if all are supported.
 * @param zwjEmojisToCheck
 * @param baselineEmoji
 * @param emojiToDomNode
 */
function checkZwjSupport(zwjEmojisToCheck, baselineEmoji, emojiToDomNode) {
  var allSupported = true;
  var _iterator3 = _createForOfIteratorHelper(zwjEmojisToCheck),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var emoji = _step3.value;
      var domNode = emojiToDomNode(emoji);
      // sanity check to make sure the node is defined properly
      /* istanbul ignore if */
      if (!domNode) {
        // This is a race condition that can occur when the component is unmounted/remounted
        // It doesn't really matter what we do here since the old context is not going to render anymore.
        // Just bail out of emoji support detection and return `allSupported=true` since the rendering context is gone
        continue;
      }
      var emojiWidth = calculateTextWidth(domNode);
      if (typeof baselineEmojiWidth === 'undefined') {
        // calculate the baseline emoji width only once
        baselineEmojiWidth = calculateTextWidth(baselineEmoji);
      }
      // On Windows, some supported emoji are ~50% bigger than the baseline emoji, but what we really want to guard
      // against are the ones that are 2x the size, because those are truly broken (person with red hair = person with
      // floating red wig, black cat = cat with black square, polar bear = bear with snowflake, etc.)
      // So here we set the threshold at 1.8 times the size of the baseline emoji.
      var supported = emojiWidth / 1.8 < baselineEmojiWidth;
      supportedZwjEmojis.set(emoji.unicode, supported);
      if (!supported) {
        allSupported = false;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return allSupported;
}

// like lodash's uniq

function uniq(arr) {
  return uniqBy(arr, function (_) {
    return _;
  });
}

// Note we put this in its own function outside Picker.js to avoid Svelte doing an invalidation on the "setter" here.
// At best the invalidation is useless, at worst it can cause infinite loops:
// https://github.com/nolanlawson/emoji-picker-element/pull/180
// https://github.com/sveltejs/svelte/issues/6521
// Also note tabpanelElement can be null if the element is disconnected immediately after connected
function resetScrollTopIfPossible(element) {
  /* istanbul ignore else */
  if (element) {
    // Makes me nervous not to have this `if` guard
    element.scrollTop = 0;
  }
}
function getFromMap(cache, key, func) {
  var cached = cache.get(key);
  if (!cached) {
    cached = func();
    cache.set(key, cached);
  }
  return cached;
}
function toString(value) {
  return '' + value;
}
function parseTemplate(htmlString) {
  var template = document.createElement('template');
  template.innerHTML = htmlString;
  return template;
}
var parseCache = new WeakMap();
var domInstancesCache = new WeakMap();
// This needs to be a symbol because it needs to be different from any possible output of a key function
var unkeyedSymbol = Symbol('un-keyed');

// Not supported in Safari <=13
var hasReplaceChildren = 'replaceChildren' in Element.prototype;
function replaceChildren(parentNode, newChildren) {
  /* istanbul ignore else */
  if (hasReplaceChildren) {
    parentNode.replaceChildren.apply(parentNode, _toConsumableArray(newChildren));
  } else {
    // minimal polyfill for Element.prototype.replaceChildren
    parentNode.innerHTML = '';
    parentNode.append.apply(parentNode, _toConsumableArray(newChildren));
  }
}
function doChildrenNeedRerender(parentNode, newChildren) {
  var oldChild = parentNode.firstChild;
  var oldChildrenCount = 0;
  // iterate using firstChild/nextSibling because browsers use a linked list under the hood
  while (oldChild) {
    var newChild = newChildren[oldChildrenCount];
    // check if the old child and new child are the same
    if (newChild !== oldChild) {
      return true;
    }
    oldChild = oldChild.nextSibling;
    oldChildrenCount++;
  }
  // if new children length is different from old, we must re-render
  return oldChildrenCount !== newChildren.length;
}
function patchChildren(newChildren, instanceBinding) {
  var targetNode = instanceBinding.targetNode;
  var targetParentNode = instanceBinding.targetParentNode;
  var needsRerender = false;
  if (targetParentNode) {
    // already rendered once
    needsRerender = doChildrenNeedRerender(targetParentNode, newChildren);
  } else {
    // first render of list
    needsRerender = true;
    instanceBinding.targetNode = undefined; // placeholder node not needed anymore, free memory
    instanceBinding.targetParentNode = targetParentNode = targetNode.parentNode;
  }
  // avoid re-rendering list if the dom nodes are exactly the same before and after
  if (needsRerender) {
    replaceChildren(targetParentNode, newChildren);
  }
}
function patch(expressions, instanceBindings) {
  var _iterator4 = _createForOfIteratorHelper(instanceBindings),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var instanceBinding = _step4.value;
      var targetNode = instanceBinding.targetNode,
        currentExpression = instanceBinding.currentExpression,
        _instanceBinding$bind = instanceBinding.binding,
        expressionIndex = _instanceBinding$bind.expressionIndex,
        attributeName = _instanceBinding$bind.attributeName,
        attributeValuePre = _instanceBinding$bind.attributeValuePre,
        attributeValuePost = _instanceBinding$bind.attributeValuePost;
      var expression = expressions[expressionIndex];
      if (currentExpression === expression) {
        // no need to update, same as before
        continue;
      }
      instanceBinding.currentExpression = expression;
      if (attributeName) {
        // attribute replacement
        if (expression === null) {
          // null is treated as a special case by the framework - we don't render an attribute at all in this case
          targetNode.removeAttribute(attributeName);
        } else {
          // attribute value is not null; set a new attribute
          var newValue = attributeValuePre + toString(expression) + attributeValuePost;
          targetNode.setAttribute(attributeName, newValue);
        }
      } else {
        // text node / child element / children replacement
        var newNode = void 0;
        if (Array.isArray(expression)) {
          // array of DOM elements produced by tag template literals
          patchChildren(expression, instanceBinding);
        } else if (expression instanceof Element) {
          // html tag template returning a DOM element
          newNode = expression;
          targetNode.replaceWith(newNode);
        } else {
          // primitive - string, number, etc
          // nodeValue is faster than textContent supposedly https://www.youtube.com/watch?v=LY6y3HbDVmg
          // note we may be replacing the value in a placeholder text node
          targetNode.nodeValue = toString(expression);
        }
        if (newNode) {
          instanceBinding.targetNode = newNode;
        }
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
}
function parse(tokens) {
  var htmlString = '';
  var withinTag = false;
  var withinAttribute = false;
  var elementIndexCounter = -1; // depth-first traversal order

  var elementsToBindings = new Map();
  var elementIndexes = [];
  var skipTokenChars = 0;
  for (var i = 0, len = tokens.length; i < len; i++) {
    var token = tokens[i];
    htmlString += token.slice(skipTokenChars);
    if (i === len - 1) {
      break; // no need to process characters - no more expressions to be found
    }
    for (var j = 0; j < token.length; j++) {
      var char = token.charAt(j);
      switch (char) {
        case '<':
          {
            var nextChar = token.charAt(j + 1);
            if (nextChar === '/') {
              // closing tag
              // leaving an element
              elementIndexes.pop();
            } else {
              // not a closing tag
              withinTag = true;
              elementIndexes.push(++elementIndexCounter);
            }
            break;
          }
        case '>':
          {
            withinTag = false;
            withinAttribute = false;
            break;
          }
        case '=':
          {
            withinAttribute = true;
            break;
          }
      }
    }
    var elementIndex = elementIndexes[elementIndexes.length - 1];
    var bindings = getFromMap(elementsToBindings, elementIndex, function () {
      return [];
    });
    var attributeName = void 0;
    var attributeValuePre = void 0;
    var attributeValuePost = void 0;
    if (withinAttribute) {
      // I never use single-quotes for attribute values in HTML, so just support double-quotes or no-quotes
      var attributePreMatch = /(\S+)="?([^"=]*)$/.exec(token);
      attributeName = attributePreMatch[1];
      attributeValuePre = attributePreMatch[2];
      var attributePostMatch = /^([^">]*)("?)/.exec(tokens[i + 1]);
      attributeValuePost = attributePostMatch[1];
      // Optimization: remove the attribute itself, so we don't create a default attribute which is either empty or just
      // the "pre" text, e.g. `<div foo>` or `<div foo="prefix">`. It will be replaced by the expression anyway.
      htmlString = htmlString.slice(0, -1 * attributePreMatch[0].length);
      skipTokenChars = attributePostMatch[0].length;
    } else {
      skipTokenChars = 0;
    }
    var binding = {
      attributeName: attributeName,
      attributeValuePre: attributeValuePre,
      attributeValuePost: attributeValuePost,
      expressionIndex: i
    };
    bindings.push(binding);
    if (!withinTag && !withinAttribute) {
      // Add a placeholder text node, so we can find it later. Note we only support one dynamic child text node
      htmlString += ' ';
    }
  }
  var template = parseTemplate(htmlString);
  return {
    template: template,
    elementsToBindings: elementsToBindings
  };
}
function applyBindings(bindings, element, instanceBindings) {
  for (var i = 0; i < bindings.length; i++) {
    var binding = bindings[i];
    var targetNode = binding.attributeName ? element // attribute binding, just use the element itself
    : element.firstChild; // not an attribute binding, so has a placeholder text node

    var instanceBinding = {
      binding: binding,
      targetNode: targetNode,
      targetParentNode: undefined,
      currentExpression: undefined
    };
    instanceBindings.push(instanceBinding);
  }
}
function traverseAndSetupBindings(rootElement, elementsToBindings) {
  var instanceBindings = [];
  var topLevelBindings;
  if (elementsToBindings.size === 1 && (topLevelBindings = elementsToBindings.get(0))) {
    // Optimization for the common case where there's only one element and one binding
    // Skip creating a TreeWalker entirely and just handle the root DOM element
    applyBindings(topLevelBindings, rootElement, instanceBindings);
  } else {
    // traverse dom
    var treeWalker = document.createTreeWalker(rootElement, NodeFilter.SHOW_ELEMENT);
    var element = rootElement;
    var elementIndex = -1;
    do {
      var bindings = elementsToBindings.get(++elementIndex);
      if (bindings) {
        applyBindings(bindings, element, instanceBindings);
      }
    } while (element = treeWalker.nextNode());
  }
  return instanceBindings;
}
function parseHtml(tokens) {
  // All templates and bound expressions are unique per tokens array
  var _getFromMap = getFromMap(parseCache, tokens, function () {
      return parse(tokens);
    }),
    template = _getFromMap.template,
    elementsToBindings = _getFromMap.elementsToBindings;

  // When we parseHtml, we always return a fresh DOM instance ready to be updated
  var dom = template.cloneNode(true).content.firstElementChild;
  var instanceBindings = traverseAndSetupBindings(dom, elementsToBindings);
  return function updateDomInstance(expressions) {
    patch(expressions, instanceBindings);
    return dom;
  };
}
function createFramework(state) {
  var domInstances = getFromMap(domInstancesCache, state, function () {
    return new Map();
  });
  var domInstanceCacheKey = unkeyedSymbol;
  function html(tokens) {
    // Each unique lexical usage of map() is considered unique due to the html`` tagged template call it makes,
    // which has lexically unique tokens. The unkeyed symbol is just used for html`` usage outside of a map().
    var domInstancesForTokens = getFromMap(domInstances, tokens, function () {
      return new Map();
    });
    var updateDomInstance = getFromMap(domInstancesForTokens, domInstanceCacheKey, function () {
      return parseHtml(tokens);
    });
    for (var _len = arguments.length, expressions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      expressions[_key - 1] = arguments[_key];
    }
    return updateDomInstance(expressions); // update with expressions
  }
  function map(array, callback, keyFunction) {
    return array.map(function (item, index) {
      var originalCacheKey = domInstanceCacheKey;
      domInstanceCacheKey = keyFunction(item);
      try {
        return callback(item, index);
      } finally {
        domInstanceCacheKey = originalCacheKey;
      }
    });
  }
  return {
    map: map,
    html: html
  };
}
function render(container, state, helpers, events, actions, refs, abortSignal, actionContext, firstRender) {
  var labelWithSkin = helpers.labelWithSkin,
    titleForEmoji = helpers.titleForEmoji,
    unicodeWithSkin = helpers.unicodeWithSkin;
  var _createFramework = createFramework(state),
    html = _createFramework.html,
    map = _createFramework.map;
  function emojiList(emojis, searchMode, prefix) {
    return map(emojis, function (emoji, i) {
      return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["<button role=\"", "\" aria-selected=\"", "\" aria-label=\"", "\" title=\"", "\" class=\"", "\" id=\"", "\" style=\"", "\">", "</button>"])), searchMode ? 'option' : 'menuitem', searchMode ? i === state.activeSearchItem : null, labelWithSkin(emoji, state.currentSkinTone), titleForEmoji(emoji), 'emoji' + (searchMode && i === state.activeSearchItem ? ' active' : '') + (emoji.unicode ? '' : ' custom-emoji'), "".concat(prefix, "-").concat(emoji.id), emoji.unicode ? null : "--custom-emoji-background: url(".concat(JSON.stringify(emoji.url), ")"), emoji.unicode ? unicodeWithSkin(emoji, state.currentSkinTone) : '');
      // It's important for the cache key to be unique based on the prefix, because the framework caches based on the
      // unique tokens + cache key, and the same emoji may be used in the tab as well as in the fav bar
    }, function (emoji) {
      return "".concat(prefix, "-").concat(emoji.id);
    });
  }
  var section = function section() {
    return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<section data-ref=\"rootElement\" class=\"picker\" aria-label=\"", "\" style=\"", "\"><div class=\"pad-top\"></div><div class=\"search-row\"><div class=\"search-wrapper\"><input id=\"search\" class=\"search\" type=\"search\" role=\"combobox\" enterkeyhint=\"search\" placeholder=\"", "\" autocapitalize=\"none\" autocomplete=\"off\" spellcheck=\"true\" aria-expanded=\"", "\" aria-controls=\"search-results\" aria-describedby=\"search-description\" aria-autocomplete=\"list\" aria-activedescendant=\"", "\" data-ref=\"searchElement\" data-on-input=\"onSearchInput\" data-on-keydown=\"onSearchKeydown\"><label class=\"sr-only\" for=\"search\">", "</label> <span id=\"search-description\" class=\"sr-only\">", "</span></div><div class=\"skintone-button-wrapper ", "\"><button id=\"skintone-button\" class=\"emoji ", "\" aria-label=\"", "\" title=\"", "\" aria-describedby=\"skintone-description\" aria-haspopup=\"listbox\" aria-expanded=\"", "\" aria-controls=\"skintone-list\" data-on-click=\"onClickSkinToneButton\">", "</button></div><span id=\"skintone-description\" class=\"sr-only\">", "</span><div data-ref=\"skinToneDropdown\" id=\"skintone-list\" class=\"skintone-list hide-focus ", "\" style=\"transform:translateY(", ")\" role=\"listbox\" aria-label=\"", "\" aria-activedescendant=\"skintone-", "\" aria-hidden=\"", "\" tabIndex=\"-1\" data-on-focusout=\"onSkinToneOptionsFocusOut\" data-on-click=\"onSkinToneOptionsClick\" data-on-keydown=\"onSkinToneOptionsKeydown\" data-on-keyup=\"onSkinToneOptionsKeyup\">", "</div></div><div class=\"nav\" role=\"tablist\" style=\"grid-template-columns:repeat(", ",1fr)\" aria-label=\"", "\" data-on-keydown=\"onNavKeydown\" data-on-click=\"onNavClick\">", "</div><div class=\"indicator-wrapper\"><div class=\"indicator\" style=\"transform:translateX(", "%)\"></div></div><div class=\"message ", "\" role=\"alert\" aria-live=\"polite\">", "</div><div data-ref=\"tabpanelElement\" class=\"tabpanel ", "\" role=\"", "\" aria-label=\"", "\" id=\"", "\" tabIndex=\"0\" data-on-click=\"onEmojiClick\"><div data-action=\"calculateEmojiGridStyle\">", "</div></div><div class=\"favorites onscreen emoji-menu ", "\" role=\"menu\" aria-label=\"", "\" data-on-click=\"onEmojiClick\">", "</div><button data-ref=\"baselineEmoji\" aria-hidden=\"true\" tabindex=\"-1\" class=\"abs-pos hidden emoji baseline-emoji\">\uD83D\uDE00</button></section>"])), state.i18n.regionLabel, state.pickerStyle || '', state.i18n.searchLabel, !!(state.searchMode && state.currentEmojis.length), state.activeSearchItemId ? "emo-".concat(state.activeSearchItemId) : null, state.i18n.searchLabel, state.i18n.searchDescription, state.skinTonePickerExpandedAfterAnimation ? 'expanded' : '', state.skinTonePickerExpanded ? 'hide-focus' : '', state.skinToneButtonLabel, state.skinToneButtonLabel, state.skinTonePickerExpanded, state.skinToneButtonText || '', state.i18n.skinToneDescription, state.skinTonePickerExpanded ? '' : 'hidden no-animate', state.skinTonePickerExpanded ? 0 : 'calc(-1 * var(--num-skintones) * var(--total-emoji-size))', state.i18n.skinTonesLabel, state.activeSkinTone, !state.skinTonePickerExpanded, map(state.skinTones, function (skinTone, i) {
      return html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<div id=\"skintone-", "\" class=\"emoji ", "\" aria-selected=\"", "\" role=\"option\" title=\"", "\" aria-label=\"", "\">", "</div>"])), i, i === state.activeSkinTone ? 'active' : '', i === state.activeSkinTone, state.i18n.skinTones[i], state.i18n.skinTones[i], skinTone);
    }, function (skinTone) {
      return skinTone;
    }), state.groups.length, state.i18n.categoriesLabel, map(state.groups, function (group) {
      return html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<button role=\"tab\" class=\"nav-button\" aria-controls=\"tab-", "\" aria-label=\"", "\" aria-selected=\"", "\" title=\"", "\" data-group-id=\"", "\"><div class=\"nav-emoji emoji\">", "</div></button>"])), group.id, state.i18n.categories[group.name], !state.searchMode && state.currentGroup.id === group.id, state.i18n.categories[group.name], group.id, group.emoji);
    }, function (group) {
      return group.id;
    }), (/* istanbul ignore next */state.isRtl ? -1 : 1) * state.currentGroupIndex * 100, state.message ? '' : 'gone', state.message || '', !state.databaseLoaded || state.message ? 'gone' : '', state.searchMode ? 'region' : 'tabpanel', state.searchMode ? state.i18n.searchResultsLabel : state.i18n.categories[state.currentGroup.name], state.searchMode ? null : "tab-".concat(state.currentGroup.id), map(state.currentEmojisWithCategories, function (emojiWithCategory, i) {
      return html(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<div><div id=\"menu-label-", "\" class=\"category ", "\" aria-hidden=\"true\">", "</div><div class=\"emoji-menu ", "\" style=\"", "\" data-action=\"updateOnIntersection\" role=\"", "\" aria-labelledby=\"menu-label-", "\" id=\"", "\">", "</div></div>"])), i, state.currentEmojisWithCategories.length === 1 && state.currentEmojisWithCategories[0].category === '' ? 'gone' : '', state.searchMode ? state.i18n.searchResultsLabel : emojiWithCategory.category ? emojiWithCategory.category : state.currentEmojisWithCategories.length > 1 ? state.i18n.categories.custom : state.i18n.categories[state.currentGroup.name], i !== 0 && !state.searchMode && state.currentGroup.id === -1 ? 'visibility-auto' : '', "--num-rows: ".concat(Math.ceil(emojiWithCategory.emojis.length / state.numColumns)), state.searchMode ? 'listbox' : 'menu', i, state.searchMode ? 'search-results' : null, emojiList(emojiWithCategory.emojis, state.searchMode, /* prefix */'emo'));
    }, function (emojiWithCategory) {
      return emojiWithCategory.category;
    }), state.message ? 'gone' : '', state.i18n.favoritesLabel, emojiList(state.currentFavorites, /* searchMode */false, /* prefix */'fav'));
  };
  var rootDom = section();

  // helper for traversing the dom, finding elements by an attribute, and getting the attribute value
  var forElementWithAttribute = function forElementWithAttribute(attributeName, callback) {
    var _iterator5 = _createForOfIteratorHelper(container.querySelectorAll("[".concat(attributeName, "]"))),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var element = _step5.value;
        callback(element, element.getAttribute(attributeName));
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  };
  if (firstRender) {
    // not a re-render
    container.appendChild(rootDom);

    // we only bind events/refs once - there is no need to find them again given this component structure

    // bind events
    var _loop = function _loop() {
      var eventName = _arr[_i2];
      forElementWithAttribute("data-on-".concat(eventName), function (element, listenerName) {
        element.addEventListener(eventName, events[listenerName]);
      });
    };
    for (var _i2 = 0, _arr = ['click', 'focusout', 'input', 'keydown', 'keyup']; _i2 < _arr.length; _i2++) {
      _loop();
    }

    // find refs
    forElementWithAttribute('data-ref', function (element, ref) {
      refs[ref] = element;
    });

    // destroy/abort logic
    abortSignal.addEventListener('abort', function () {
      container.removeChild(rootDom);
    });
  }

  // set up actions - these are re-bound on every render
  forElementWithAttribute('data-action', function (element, action) {
    var boundActions = actionContext.get(action);
    if (!boundActions) {
      actionContext.set(action, boundActions = new WeakSet());
    }

    // avoid applying the same action to the same element multiple times
    if (!boundActions.has(element)) {
      boundActions.add(element);
      actions[action](element);
    }
  });
}

/* istanbul ignore next */
var qM = typeof queueMicrotask === 'function' ? queueMicrotask : function (callback) {
  return Promise.resolve().then(callback);
};
function createState(abortSignal) {
  var destroyed = false;
  var currentObserver;
  var propsToObservers = new Map();
  var dirtyObservers = new Set();
  var queued;
  var _flush = function flush() {
    if (destroyed) {
      return;
    }
    var observersToRun = _toConsumableArray(dirtyObservers);
    dirtyObservers.clear(); // clear before running to force any new updates to run in another tick of the loop
    try {
      var _iterator6 = _createForOfIteratorHelper(observersToRun),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var observer = _step6.value;
          observer();
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    } finally {
      queued = false;
      if (dirtyObservers.size) {
        // new updates, queue another one
        queued = true;
        qM(_flush);
      }
    }
  };
  var state = new Proxy({}, {
    get: function get(target, prop) {
      if (currentObserver) {
        var observers = propsToObservers.get(prop);
        if (!observers) {
          observers = new Set();
          propsToObservers.set(prop, observers);
        }
        observers.add(currentObserver);
      }
      return target[prop];
    },
    set: function set(target, prop, newValue) {
      if (target[prop] !== newValue) {
        target[prop] = newValue;
        var observers = propsToObservers.get(prop);
        if (observers) {
          var _iterator7 = _createForOfIteratorHelper(observers),
            _step7;
          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var observer = _step7.value;
              dirtyObservers.add(observer);
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
          if (!queued) {
            queued = true;
            qM(_flush);
          }
        }
      }
      return true;
    }
  });
  var createEffect = function createEffect(callback) {
    var _runnable = function runnable() {
      var oldObserver = currentObserver;
      currentObserver = _runnable;
      try {
        return callback();
      } finally {
        currentObserver = oldObserver;
      }
    };
    return _runnable();
  };

  // destroy logic
  abortSignal.addEventListener('abort', function () {
    destroyed = true;
  });
  return {
    state: state,
    createEffect: createEffect
  };
}

// Compare two arrays, with a function called on each item in the two arrays that returns true if the items are equal
function arraysAreEqualByFunction(left, right, areEqualFunc) {
  if (left.length !== right.length) {
    return false;
  }
  for (var i = 0; i < left.length; i++) {
    if (!areEqualFunc(left[i], right[i])) {
      return false;
    }
  }
  return true;
}
var intersectionObserverCache = new WeakMap();
function intersectionObserverAction(node, abortSignal, listener) {
  /* istanbul ignore else */
  {
    // The scroll root is always `.tabpanel`
    var root = node.closest('.tabpanel');
    var observer = intersectionObserverCache.get(root);
    if (!observer) {
      // TODO: replace this with the contentvisibilityautostatechange event when all supported browsers support it.
      // For now we use IntersectionObserver because it has better cross-browser support, and it would be bad for
      // old Safari versions if they eagerly downloaded all custom emoji all at once.
      observer = new IntersectionObserver(listener, {
        root: root,
        // trigger if we are 1/2 scroll container height away so that the images load a bit quicker while scrolling
        rootMargin: '50% 0px 50% 0px',
        // trigger if any part of the emoji grid is intersecting
        threshold: 0
      });

      // avoid creating a new IntersectionObserver for every category; just use one for the whole root
      intersectionObserverCache.set(root, observer);

      // assume that the abortSignal is always the same for this root node; just add one event listener
      abortSignal.addEventListener('abort', function () {
        observer.disconnect();
      });
    }
    observer.observe(node);
  }
}

/* eslint-disable prefer-const,no-labels,no-inner-declarations */

// constants
var EMPTY_ARRAY = [];
var assign = Object.assign;
function createRoot(shadowRoot, props) {
  var refs = {};
  var abortController = new AbortController();
  var abortSignal = abortController.signal;
  var _createState = createState(abortSignal),
    state = _createState.state,
    createEffect = _createState.createEffect;
  var actionContext = new Map();

  // initial state
  assign(state, {
    skinToneEmoji: undefined,
    i18n: undefined,
    database: undefined,
    customEmoji: undefined,
    customCategorySorting: undefined,
    emojiVersion: undefined
  });

  // public props
  assign(state, props);

  // private props
  assign(state, {
    initialLoad: true,
    currentEmojis: [],
    currentEmojisWithCategories: [],
    rawSearchText: '',
    searchText: '',
    searchMode: false,
    activeSearchItem: -1,
    message: undefined,
    skinTonePickerExpanded: false,
    skinTonePickerExpandedAfterAnimation: false,
    currentSkinTone: 0,
    activeSkinTone: 0,
    skinToneButtonText: undefined,
    pickerStyle: undefined,
    skinToneButtonLabel: '',
    skinTones: [],
    currentFavorites: [],
    defaultFavoriteEmojis: undefined,
    numColumns: DEFAULT_NUM_COLUMNS,
    isRtl: false,
    currentGroupIndex: 0,
    groups: groups,
    databaseLoaded: false,
    activeSearchItemId: undefined
  });

  //
  // Update the current group based on the currentGroupIndex
  //
  createEffect(function () {
    if (state.currentGroup !== state.groups[state.currentGroupIndex]) {
      state.currentGroup = state.groups[state.currentGroupIndex];
    }
  });

  //
  // Utils/helpers
  //

  var focus = function focus(id) {
    shadowRoot.getElementById(id).focus();
  };
  var emojiToDomNode = function emojiToDomNode(emoji) {
    return shadowRoot.getElementById("emo-".concat(emoji.id));
  };

  // fire a custom event that crosses the shadow boundary
  var fireEvent = function fireEvent(name, detail) {
    refs.rootElement.dispatchEvent(new CustomEvent(name, {
      detail: detail,
      bubbles: true,
      composed: true
    }));
  };

  //
  // Comparison utils
  //

  var compareEmojiArrays = function compareEmojiArrays(a, b) {
    return a.id === b.id;
  };
  var compareCurrentEmojisWithCategories = function compareCurrentEmojisWithCategories(a, b) {
    var aCategory = a.category,
      aEmojis = a.emojis;
    var bCategory = b.category,
      bEmojis = b.emojis;
    if (aCategory !== bCategory) {
      return false;
    }
    return arraysAreEqualByFunction(aEmojis, bEmojis, compareEmojiArrays);
  };

  //
  // Update utils to avoid excessive re-renders
  //

  // avoid excessive re-renders by checking the value before setting
  var updateCurrentEmojis = function updateCurrentEmojis(newEmojis) {
    if (!arraysAreEqualByFunction(state.currentEmojis, newEmojis, compareEmojiArrays)) {
      state.currentEmojis = newEmojis;
    }
  };

  // avoid excessive re-renders
  var updateSearchMode = function updateSearchMode(newSearchMode) {
    if (state.searchMode !== newSearchMode) {
      state.searchMode = newSearchMode;
    }
  };

  // avoid excessive re-renders
  var updateCurrentEmojisWithCategories = function updateCurrentEmojisWithCategories(newEmojisWithCategories) {
    if (!arraysAreEqualByFunction(state.currentEmojisWithCategories, newEmojisWithCategories, compareCurrentEmojisWithCategories)) {
      state.currentEmojisWithCategories = newEmojisWithCategories;
    }
  };

  // Helpers used by PickerTemplate

  var unicodeWithSkin = function unicodeWithSkin(emoji, currentSkinTone) {
    return currentSkinTone && emoji.skins && emoji.skins[currentSkinTone] || emoji.unicode;
  };
  var labelWithSkin = function labelWithSkin(emoji, currentSkinTone) {
    return uniq([emoji.name || unicodeWithSkin(emoji, currentSkinTone), emoji.annotation].concat(_toConsumableArray(emoji.shortcodes || EMPTY_ARRAY)).filter(Boolean)).join(', ');
  };
  var titleForEmoji = function titleForEmoji(emoji) {
    return emoji.annotation || (emoji.shortcodes || EMPTY_ARRAY).join(', ');
  };
  var helpers = {
    labelWithSkin: labelWithSkin,
    titleForEmoji: titleForEmoji,
    unicodeWithSkin: unicodeWithSkin
  };
  var events = {
    onClickSkinToneButton: onClickSkinToneButton,
    onEmojiClick: onEmojiClick,
    onNavClick: onNavClick,
    onNavKeydown: onNavKeydown,
    onSearchKeydown: onSearchKeydown,
    onSkinToneOptionsClick: onSkinToneOptionsClick,
    onSkinToneOptionsFocusOut: onSkinToneOptionsFocusOut,
    onSkinToneOptionsKeydown: onSkinToneOptionsKeydown,
    onSkinToneOptionsKeyup: onSkinToneOptionsKeyup,
    onSearchInput: onSearchInput
  };
  var actions = {
    calculateEmojiGridStyle: calculateEmojiGridStyle,
    updateOnIntersection: updateOnIntersection
  };
  var firstRender = true;
  createEffect(function () {
    render(shadowRoot, state, helpers, events, actions, refs, abortSignal, actionContext, firstRender);
    firstRender = false;
  });

  //
  // Determine the emoji support level (in requestIdleCallback)
  //

  // mount logic
  if (!state.emojiVersion) {
    detectEmojiSupportLevel().then(function (level) {
      // Can't actually test emoji support in Jest/Vitest/JSDom, emoji never render in color in Cairo
      /* istanbul ignore next */
      if (!level) {
        state.message = state.i18n.emojiUnsupportedMessage;
      }
    });
  }

  //
  // Set or update the database object
  //

  createEffect(function () {
    // show a Loading message if it takes a long time, or show an error if there's a network/IDB error
    function handleDatabaseLoading() {
      return _handleDatabaseLoading.apply(this, arguments);
    }
    function _handleDatabaseLoading() {
      _handleDatabaseLoading = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var showingLoadingMessage, timeoutHandle, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              showingLoadingMessage = false;
              timeoutHandle = setTimeout(function () {
                showingLoadingMessage = true;
                state.message = state.i18n.loadingMessage;
              }, TIMEOUT_BEFORE_LOADING_MESSAGE);
              _context.p = 1;
              _context.n = 2;
              return state.database.ready();
            case 2:
              state.databaseLoaded = true; // eslint-disable-line no-unused-vars
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error(_t);
              state.message = state.i18n.networkErrorMessage;
            case 4:
              _context.p = 4;
              clearTimeout(timeoutHandle);
              if (showingLoadingMessage) {
                // Seems safer than checking the i18n string, which may change
                showingLoadingMessage = false;
                state.message = ''; // eslint-disable-line no-unused-vars
              }
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return _handleDatabaseLoading.apply(this, arguments);
    }
    if (state.database) {
      /* no await */
      handleDatabaseLoading();
    }
  });

  //
  // Global styles for the entire picker
  //

  createEffect(function () {
    state.pickerStyle = "\n      --num-groups: ".concat(state.groups.length, "; \n      --indicator-opacity: ").concat(state.searchMode ? 0 : 1, "; \n      --num-skintones: ").concat(NUM_SKIN_TONES, ";");
  });

  //
  // Set or update the customEmoji
  //

  createEffect(function () {
    if (state.customEmoji && state.database) {
      updateCustomEmoji(); // re-run whenever customEmoji change
    }
  });
  createEffect(function () {
    if (state.customEmoji && state.customEmoji.length) {
      if (state.groups !== allGroups) {
        // don't update unnecessarily
        state.groups = allGroups;
      }
    } else if (state.groups !== groups) {
      if (state.currentGroupIndex) {
        // If the current group is anything other than "custom" (which is first), decrement.
        // This fixes the odd case where you set customEmoji, then pick a category, then unset customEmoji
        state.currentGroupIndex--;
      }
      state.groups = groups;
    }
  });

  //
  // Set or update the preferred skin tone
  //

  createEffect(function () {
    function updatePreferredSkinTone() {
      return _updatePreferredSkinTone.apply(this, arguments);
    }
    /* no await */
    function _updatePreferredSkinTone() {
      _updatePreferredSkinTone = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!state.databaseLoaded) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return state.database.getPreferredSkinTone();
            case 1:
              state.currentSkinTone = _context2.v;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return _updatePreferredSkinTone.apply(this, arguments);
    }
    updatePreferredSkinTone();
  });
  createEffect(function () {
    state.skinTones = Array(NUM_SKIN_TONES).fill().map(function (_, i) {
      return applySkinTone(state.skinToneEmoji, i);
    });
  });
  createEffect(function () {
    state.skinToneButtonText = state.skinTones[state.currentSkinTone];
  });
  createEffect(function () {
    state.skinToneButtonLabel = state.i18n.skinToneLabel.replace('{skinTone}', state.i18n.skinTones[state.currentSkinTone]);
  });

  //
  // Set or update the favorites emojis
  //

  createEffect(function () {
    function updateDefaultFavoriteEmojis() {
      return _updateDefaultFavoriteEmojis.apply(this, arguments);
    }
    function _updateDefaultFavoriteEmojis() {
      _updateDefaultFavoriteEmojis = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var database, favs;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              database = state.database;
              _context3.n = 1;
              return Promise.all(MOST_COMMONLY_USED_EMOJI.map(function (unicode) {
                return database.getEmojiByUnicodeOrName(unicode);
              }));
            case 1:
              favs = _context3.v.filter(Boolean);
              // filter because in Jest/Vitest tests we don't have all the emoji in the DB
              state.defaultFavoriteEmojis = favs;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return _updateDefaultFavoriteEmojis.apply(this, arguments);
    }
    if (state.databaseLoaded) {
      /* no await */updateDefaultFavoriteEmojis();
    }
  });
  function updateCustomEmoji() {
    // Certain effects have an implicit dependency on customEmoji since it affects the database
    // Getting it here on the state ensures this effect re-runs when customEmoji change.
    var customEmoji = state.customEmoji,
      database = state.database;
    var databaseCustomEmoji = customEmoji || EMPTY_ARRAY;
    if (database.customEmoji !== databaseCustomEmoji) {
      // Avoid setting this if the customEmoji have _not_ changed, because the setter triggers a re-computation of the
      // `customEmojiIndex`. Note we don't bother with deep object changes.
      database.customEmoji = databaseCustomEmoji;
    }
  }
  createEffect(function () {
    function updateFavorites() {
      return _updateFavorites.apply(this, arguments);
    }
    function _updateFavorites() {
      _updateFavorites = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var database, defaultFavoriteEmojis, numColumns, dbFavorites, favorites;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              updateCustomEmoji(); // re-run whenever customEmoji change
              database = state.database, defaultFavoriteEmojis = state.defaultFavoriteEmojis, numColumns = state.numColumns;
              _context4.n = 1;
              return database.getTopFavoriteEmoji(numColumns);
            case 1:
              dbFavorites = _context4.v;
              _context4.n = 2;
              return summarizeEmojis(uniqBy([].concat(_toConsumableArray(dbFavorites), _toConsumableArray(defaultFavoriteEmojis)), function (_) {
                return _.unicode || _.name;
              }).slice(0, numColumns));
            case 2:
              favorites = _context4.v;
              state.currentFavorites = favorites;
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return _updateFavorites.apply(this, arguments);
    }
    if (state.databaseLoaded && state.defaultFavoriteEmojis) {
      /* no await */updateFavorites();
    }
  });

  //
  // Re-run whenever the emoji grid changes size, and re-calc style/layout-related state variables:
  // 1) Re-calculate the --num-columns var because it may have changed
  // 2) Re-calculate whether we're in RTL mode or not.
  //
  // The benefit of doing this in one place is to align with rAF/ResizeObserver
  // and do all the calculations in one go. RTL vs LTR is not strictly layout-related,
  // but since we're already reading the style here, and since it's already aligned with
  // the rAF loop, this is the most appropriate place to do it perf-wise.
  //

  function calculateEmojiGridStyle(node) {
    resizeObserverAction(node, abortSignal, function () {
      /* istanbul ignore next */
      {
        // jsdom throws errors for this kind of fancy stuff
        // read all the style/layout calculations we need to make
        var style = getComputedStyle(refs.rootElement);
        var newNumColumns = parseInt(style.getPropertyValue('--num-columns'), 10);
        var newIsRtl = style.getPropertyValue('direction') === 'rtl';

        // write to state variables
        state.numColumns = newNumColumns;
        state.isRtl = newIsRtl;
      }
    });
  }

  // Re-run whenever the custom emoji in a category are shown/hidden. This is an optimization that simulates
  // what we'd get from `<img loading=lazy>` but without rendering an `<img>`.
  function updateOnIntersection(node) {
    intersectionObserverAction(node, abortSignal, function (entries) {
      var _iterator8 = _createForOfIteratorHelper(entries),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _ref6 = _step8.value;
          var target = _ref6.target;
          var isIntersecting = _ref6.isIntersecting;
          target.classList.toggle('onscreen', isIntersecting);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    });
  }

  //
  // Set or update the currentEmojis. Check for invalid ZWJ renderings
  // (i.e. double emoji).
  //

  createEffect(function () {
    function updateEmojis() {
      return _updateEmojis.apply(this, arguments);
    }
    /* no await */
    function _updateEmojis() {
      _updateEmojis = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var searchText, currentGroup, databaseLoaded, customEmoji, newEmojis, currentGroupId, _newEmojis;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              searchText = state.searchText, currentGroup = state.currentGroup, databaseLoaded = state.databaseLoaded, customEmoji = state.customEmoji;
              if (databaseLoaded) {
                _context5.n = 1;
                break;
              }
              state.currentEmojis = [];
              state.searchMode = false;
              _context5.n = 5;
              break;
            case 1:
              if (!(searchText.length >= MIN_SEARCH_TEXT_LENGTH)) {
                _context5.n = 3;
                break;
              }
              _context5.n = 2;
              return getEmojisBySearchQuery(searchText);
            case 2:
              newEmojis = _context5.v;
              if (state.searchText === searchText) {
                // if the situation changes asynchronously, do not update
                updateCurrentEmojis(newEmojis);
                updateSearchMode(true);
              }
              _context5.n = 5;
              break;
            case 3:
              // database is loaded and we're not in search mode, so we're in normal category mode
              currentGroupId = currentGroup.id; // avoid race condition where currentGroupId is -1 and customEmoji is undefined/empty
              if (!(currentGroupId !== -1 || customEmoji && customEmoji.length)) {
                _context5.n = 5;
                break;
              }
              _context5.n = 4;
              return getEmojisByGroup(currentGroupId);
            case 4:
              _newEmojis = _context5.v;
              if (state.currentGroup.id === currentGroupId) {
                // if the situation changes asynchronously, do not update
                updateCurrentEmojis(_newEmojis);
                updateSearchMode(false);
              }
            case 5:
              return _context5.a(2);
          }
        }, _callee5);
      }));
      return _updateEmojis.apply(this, arguments);
    }
    updateEmojis();
  });
  var resetScrollTopInRaf = function resetScrollTopInRaf() {
    rAF(function () {
      return resetScrollTopIfPossible(refs.tabpanelElement);
    });
  };

  // Some emojis have their ligatures rendered as two or more consecutive emojis
  // We want to treat these the same as unsupported emojis, so we compare their
  // widths against the baseline widths and remove them as necessary
  createEffect(function () {
    var currentEmojis = state.currentEmojis,
      emojiVersion = state.emojiVersion;
    var zwjEmojisToCheck = currentEmojis.filter(function (emoji) {
      return emoji.unicode;
    }) // filter custom emoji
    .filter(function (emoji) {
      return hasZwj(emoji) && !supportedZwjEmojis.has(emoji.unicode);
    });
    if (!emojiVersion && zwjEmojisToCheck.length) {
      // render now, check their length later
      updateCurrentEmojis(currentEmojis);
      rAF(function () {
        return checkZwjSupportAndUpdate(zwjEmojisToCheck);
      });
    } else {
      var newEmojis = emojiVersion ? currentEmojis : currentEmojis.filter(isZwjSupported);
      updateCurrentEmojis(newEmojis);
      // Reset scroll top to 0 when emojis change
      resetScrollTopInRaf();
    }
  });
  function checkZwjSupportAndUpdate(zwjEmojisToCheck) {
    var allSupported = checkZwjSupport(zwjEmojisToCheck, refs.baselineEmoji, emojiToDomNode);
    if (allSupported) {
      // Even if all emoji are supported, we still need to reset the scroll top to 0 when emojis change
      resetScrollTopInRaf();
    } else {
      // Force update. We only do this if there are any unsupported ZWJ characters since otherwise,
      // for browsers that support all emoji, it would be an unnecessary extra re-render.
      state.currentEmojis = _toConsumableArray(state.currentEmojis);
    }
  }
  function isZwjSupported(emoji) {
    return !emoji.unicode || !hasZwj(emoji) || supportedZwjEmojis.get(emoji.unicode);
  }
  function filterEmojisByVersion(_x) {
    return _filterEmojisByVersion.apply(this, arguments);
  }
  function _filterEmojisByVersion() {
    _filterEmojisByVersion = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(emojis) {
      var emojiSupportLevel, _t2;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            _t2 = state.emojiVersion;
            if (_t2) {
              _context7.n = 2;
              break;
            }
            _context7.n = 1;
            return detectEmojiSupportLevel();
          case 1:
            _t2 = _context7.v;
          case 2:
            emojiSupportLevel = _t2;
            return _context7.a(2, emojis.filter(function (_ref0) {
              var version = _ref0.version;
              return !version || version <= emojiSupportLevel;
            }));
        }
      }, _callee7);
    }));
    return _filterEmojisByVersion.apply(this, arguments);
  }
  function summarizeEmojis(_x2) {
    return _summarizeEmojis.apply(this, arguments);
  }
  function _summarizeEmojis() {
    _summarizeEmojis = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(emojis) {
      var _t3, _t4, _t5, _t6;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            _t3 = summarizeEmojisForUI;
            _t4 = emojis;
            _t5 = state.emojiVersion;
            if (_t5) {
              _context8.n = 2;
              break;
            }
            _context8.n = 1;
            return detectEmojiSupportLevel();
          case 1:
            _t5 = _context8.v;
          case 2:
            _t6 = _t5;
            return _context8.a(2, _t3(_t4, _t6));
        }
      }, _callee8);
    }));
    return _summarizeEmojis.apply(this, arguments);
  }
  function getEmojisByGroup(_x3) {
    return _getEmojisByGroup.apply(this, arguments);
  }
  function _getEmojisByGroup() {
    _getEmojisByGroup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(group) {
      var emoji, _t7, _t8, _t9;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.n) {
          case 0:
            if (!(group === -1)) {
              _context9.n = 1;
              break;
            }
            _t7 = state.customEmoji;
            _context9.n = 3;
            break;
          case 1:
            _context9.n = 2;
            return state.database.getEmojiByGroup(group);
          case 2:
            _t7 = _context9.v;
          case 3:
            emoji = _t7;
            _t8 = summarizeEmojis;
            _context9.n = 4;
            return filterEmojisByVersion(emoji);
          case 4:
            _t9 = _context9.v;
            return _context9.a(2, _t8(_t9));
        }
      }, _callee9);
    }));
    return _getEmojisByGroup.apply(this, arguments);
  }
  function getEmojisBySearchQuery(_x4) {
    return _getEmojisBySearchQuery.apply(this, arguments);
  }
  function _getEmojisBySearchQuery() {
    _getEmojisBySearchQuery = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(query) {
      var _t0, _t1, _t10, _t11;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.n) {
          case 0:
            _t0 = summarizeEmojis;
            _t1 = filterEmojisByVersion;
            _context0.n = 1;
            return state.database.getEmojiBySearchQuery(query);
          case 1:
            _t10 = _context0.v;
            _context0.n = 2;
            return _t1(_t10);
          case 2:
            _t11 = _context0.v;
            return _context0.a(2, _t0(_t11));
        }
      }, _callee0);
    }));
    return _getEmojisBySearchQuery.apply(this, arguments);
  }
  createEffect(function () {});

  //
  // Derive currentEmojisWithCategories from currentEmojis. This is always done even if there
  // are no categories, because it's just easier to code the HTML this way.
  //

  createEffect(function () {
    function calculateCurrentEmojisWithCategories() {
      var searchMode = state.searchMode,
        currentEmojis = state.currentEmojis;
      if (searchMode) {
        return [{
          category: '',
          emojis: currentEmojis
        }];
      }
      var categoriesToEmoji = new Map();
      var _iterator9 = _createForOfIteratorHelper(currentEmojis),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var emoji = _step9.value;
          var category = emoji.category || '';
          var emojis = categoriesToEmoji.get(category);
          if (!emojis) {
            emojis = [];
            categoriesToEmoji.set(category, emojis);
          }
          emojis.push(emoji);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      return _toConsumableArray(categoriesToEmoji.entries()).map(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
          category = _ref8[0],
          emojis = _ref8[1];
        return {
          category: category,
          emojis: emojis
        };
      }).sort(function (a, b) {
        return state.customCategorySorting(a.category, b.category);
      });
    }
    var newEmojisWithCategories = calculateCurrentEmojisWithCategories();
    updateCurrentEmojisWithCategories(newEmojisWithCategories);
  });

  //
  // Handle active search item (i.e. pressing up or down while searching)
  //

  createEffect(function () {
    state.activeSearchItemId = state.activeSearchItem !== -1 && state.currentEmojis[state.activeSearchItem].id;
  });

  //
  // Handle user input on the search input
  //

  createEffect(function () {
    var rawSearchText = state.rawSearchText;
    rIC(function () {
      state.searchText = (rawSearchText || '').trim(); // defer to avoid input delays, plus we can trim here
      state.activeSearchItem = -1;
    });
  });
  function onSearchKeydown(event) {
    if (!state.searchMode || !state.currentEmojis.length) {
      return;
    }
    var goToNextOrPrevious = function goToNextOrPrevious(previous) {
      halt(event);
      state.activeSearchItem = incrementOrDecrement(previous, state.activeSearchItem, state.currentEmojis);
    };
    switch (event.key) {
      case 'ArrowDown':
        return goToNextOrPrevious(false);
      case 'ArrowUp':
        return goToNextOrPrevious(true);
      case 'Enter':
        if (state.activeSearchItem === -1) {
          // focus the first option in the list since the list must be non-empty at this point (it's verified above)
          state.activeSearchItem = 0;
        } else {
          // there is already an active search item
          halt(event);
          return clickEmoji(state.currentEmojis[state.activeSearchItem].id);
        }
    }
  }

  //
  // Handle user input on nav
  //

  function onNavClick(event) {
    var target = event.target;
    var closestTarget = target.closest('.nav-button');
    /* istanbul ignore if */
    if (!closestTarget) {
      return; // This should never happen, but makes me nervous not to have it
    }
    var groupId = parseInt(closestTarget.dataset.groupId, 10);
    refs.searchElement.value = ''; // clear search box input
    state.rawSearchText = '';
    state.searchText = '';
    state.activeSearchItem = -1;
    state.currentGroupIndex = state.groups.findIndex(function (_) {
      return _.id === groupId;
    });
  }
  function onNavKeydown(event) {
    var target = event.target,
      key = event.key;
    var doFocus = function doFocus(el) {
      if (el) {
        halt(event);
        el.focus();
      }
    };
    switch (key) {
      case 'ArrowLeft':
        return doFocus(target.previousElementSibling);
      case 'ArrowRight':
        return doFocus(target.nextElementSibling);
      case 'Home':
        return doFocus(target.parentElement.firstElementChild);
      case 'End':
        return doFocus(target.parentElement.lastElementChild);
    }
  }

  //
  // Handle user input on an emoji
  //
  function clickEmoji(_x5) {
    return _clickEmoji.apply(this, arguments);
  }
  function _clickEmoji() {
    _clickEmoji = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(unicodeOrName) {
      var emoji, emojiSummary, skinTonedUnicode;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.n) {
          case 0:
            _context1.n = 1;
            return state.database.getEmojiByUnicodeOrName(unicodeOrName);
          case 1:
            emoji = _context1.v;
            emojiSummary = [].concat(_toConsumableArray(state.currentEmojis), _toConsumableArray(state.currentFavorites)).find(function (_) {
              return _.id === unicodeOrName;
            });
            skinTonedUnicode = emojiSummary.unicode && unicodeWithSkin(emojiSummary, state.currentSkinTone);
            _context1.n = 2;
            return state.database.incrementFavoriteEmojiCount(unicodeOrName);
          case 2:
            fireEvent('emoji-click', _objectSpread(_objectSpread({
              emoji: emoji,
              skinTone: state.currentSkinTone
            }, skinTonedUnicode && {
              unicode: skinTonedUnicode
            }), emojiSummary.name && {
              name: emojiSummary.name
            }));
          case 3:
            return _context1.a(2);
        }
      }, _callee1);
    }));
    return _clickEmoji.apply(this, arguments);
  }
  function onEmojiClick(_x6) {
    return _onEmojiClick.apply(this, arguments);
  } //
  // Handle user input on the skintone picker
  //
  function _onEmojiClick() {
    _onEmojiClick = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(event) {
      var target, id;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.n) {
          case 0:
            target = event.target;
            /* istanbul ignore if */
            if (target.classList.contains('emoji')) {
              _context10.n = 1;
              break;
            }
            return _context10.a(2);
          case 1:
            halt(event);
            id = target.id.substring(4); // replace 'emo-' or 'fav-' prefix
            /* no await */
            clickEmoji(id);
          case 2:
            return _context10.a(2);
        }
      }, _callee10);
    }));
    return _onEmojiClick.apply(this, arguments);
  }
  function changeSkinTone(skinTone) {
    state.currentSkinTone = skinTone;
    state.skinTonePickerExpanded = false;
    focus('skintone-button');
    fireEvent('skin-tone-change', {
      skinTone: skinTone
    });
    /* no await */
    state.database.setPreferredSkinTone(skinTone);
  }
  function onSkinToneOptionsClick(event) {
    var id = event.target.id;
    var match = id && id.match(/^skintone-(\d)/); // skintone option format
    /* istanbul ignore if */
    if (!match) {
      // not a skintone option
      return; // This should never happen, but makes me nervous not to have it
    }
    halt(event);
    var skinTone = parseInt(match[1], 10); // remove 'skintone-' prefix
    changeSkinTone(skinTone);
  }
  function onClickSkinToneButton(event) {
    state.skinTonePickerExpanded = !state.skinTonePickerExpanded;
    state.activeSkinTone = state.currentSkinTone;
    // this should always be true, since the button is obscured by the listbox, so this `if` is just to be sure
    if (state.skinTonePickerExpanded) {
      halt(event);
      rAF(function () {
        return focus('skintone-list');
      });
    }
  }

  // To make the animation nicer, change the z-index of the skintone picker button
  // *after* the animation has played. This makes it appear that the picker box
  // is expanding "below" the button
  createEffect(function () {
    if (state.skinTonePickerExpanded) {
      refs.skinToneDropdown.addEventListener('transitionend', function () {
        state.skinTonePickerExpandedAfterAnimation = true; // eslint-disable-line no-unused-vars
      }, {
        once: true
      });
    } else {
      state.skinTonePickerExpandedAfterAnimation = false; // eslint-disable-line no-unused-vars
    }
  });
  function onSkinToneOptionsKeydown(event) {
    // this should never happen, but makes me nervous not to have it
    /* istanbul ignore if */
    if (!state.skinTonePickerExpanded) {
      return;
    }
    var changeActiveSkinTone = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(nextSkinTone) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              halt(event);
              state.activeSkinTone = nextSkinTone;
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      return function changeActiveSkinTone(_x7) {
        return _ref9.apply(this, arguments);
      };
    }();
    switch (event.key) {
      case 'ArrowUp':
        return changeActiveSkinTone(incrementOrDecrement(true, state.activeSkinTone, state.skinTones));
      case 'ArrowDown':
        return changeActiveSkinTone(incrementOrDecrement(false, state.activeSkinTone, state.skinTones));
      case 'Home':
        return changeActiveSkinTone(0);
      case 'End':
        return changeActiveSkinTone(state.skinTones.length - 1);
      case 'Enter':
        // enter on keydown, space on keyup. this is just how browsers work for buttons
        // https://lists.w3.org/Archives/Public/w3c-wai-ig/2019JanMar/0086.html
        halt(event);
        return changeSkinTone(state.activeSkinTone);
      case 'Escape':
        halt(event);
        state.skinTonePickerExpanded = false;
        return focus('skintone-button');
    }
  }
  function onSkinToneOptionsKeyup(event) {
    // this should never happen, but makes me nervous not to have it
    /* istanbul ignore if */
    if (!state.skinTonePickerExpanded) {
      return;
    }
    switch (event.key) {
      case ' ':
        // enter on keydown, space on keyup. this is just how browsers work for buttons
        // https://lists.w3.org/Archives/Public/w3c-wai-ig/2019JanMar/0086.html
        halt(event);
        return changeSkinTone(state.activeSkinTone);
    }
  }
  function onSkinToneOptionsFocusOut(_x8) {
    return _onSkinToneOptionsFocusOut.apply(this, arguments);
  }
  function _onSkinToneOptionsFocusOut() {
    _onSkinToneOptionsFocusOut = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(event) {
      var relatedTarget;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.n) {
          case 0:
            // On blur outside of the skintone listbox, collapse the skintone picker.
            relatedTarget = event.relatedTarget; // The `else` should never happen, but makes me nervous not to have it
            /* istanbul ignore else */
            if (!relatedTarget || relatedTarget.id !== 'skintone-list') {
              state.skinTonePickerExpanded = false;
            }
          case 1:
            return _context11.a(2);
        }
      }, _callee11);
    }));
    return _onSkinToneOptionsFocusOut.apply(this, arguments);
  }
  function onSearchInput(event) {
    state.rawSearchText = event.target.value;
  }
  return {
    $set: function $set(newState) {
      assign(state, newState);
    },
    $destroy: function $destroy() {
      abortController.abort();
    }
  };
}
var DEFAULT_DATA_SOURCE = 'https://cdn.jsdelivr.net/npm/emoji-picker-element-data@^1/en/emojibase/data.json';
var DEFAULT_LOCALE = 'en';
var enI18n = {
  categoriesLabel: 'Categories',
  emojiUnsupportedMessage: 'Your browser does not support color emoji.',
  favoritesLabel: 'Favorites',
  loadingMessage: 'Loading…',
  networkErrorMessage: 'Could not load emoji.',
  regionLabel: 'Emoji picker',
  searchDescription: 'When search results are available, press up or down to select and enter to choose.',
  searchLabel: 'Search',
  searchResultsLabel: 'Search results',
  skinToneDescription: 'When expanded, press up or down to select and enter to choose.',
  skinToneLabel: 'Choose a skin tone (currently {skinTone})',
  skinTonesLabel: 'Skin tones',
  skinTones: ['Default', 'Light', 'Medium-Light', 'Medium', 'Medium-Dark', 'Dark'],
  categories: {
    custom: 'Custom',
    'smileys-emotion': 'Smileys and emoticons',
    'people-body': 'People and body',
    'animals-nature': 'Animals and nature',
    'food-drink': 'Food and drink',
    'travel-places': 'Travel and places',
    activities: 'Activities',
    objects: 'Objects',
    symbols: 'Symbols',
    flags: 'Flags'
  }
};
var baseStyles = ":host{--emoji-size:1.375rem;--emoji-padding:0.5rem;--category-emoji-size:var(--emoji-size);--category-emoji-padding:var(--emoji-padding);--indicator-height:3px;--input-border-radius:0.5rem;--input-border-size:1px;--input-font-size:1rem;--input-line-height:1.5;--input-padding:0.25rem;--num-columns:8;--outline-size:2px;--border-size:1px;--border-radius:0;--skintone-border-radius:1rem;--category-font-size:1rem;display:flex;width:min-content;height:400px}:host,:host(.light){color-scheme:light;--background:#fff;--border-color:#e0e0e0;--indicator-color:#385ac1;--input-border-color:#999;--input-font-color:#111;--input-placeholder-color:#999;--outline-color:#999;--category-font-color:#111;--button-active-background:#e6e6e6;--button-hover-background:#d9d9d9}:host(.dark){color-scheme:dark;--background:#222;--border-color:#444;--indicator-color:#5373ec;--input-border-color:#ccc;--input-font-color:#efefef;--input-placeholder-color:#ccc;--outline-color:#fff;--category-font-color:#efefef;--button-active-background:#555555;--button-hover-background:#484848}@media (prefers-color-scheme:dark){:host{color-scheme:dark;--background:#222;--border-color:#444;--indicator-color:#5373ec;--input-border-color:#ccc;--input-font-color:#efefef;--input-placeholder-color:#ccc;--outline-color:#fff;--category-font-color:#efefef;--button-active-background:#555555;--button-hover-background:#484848}}:host([hidden]){display:none}button{margin:0;padding:0;border:0;background:0 0;box-shadow:none;-webkit-tap-highlight-color:transparent}button::-moz-focus-inner{border:0}input{padding:0;margin:0;line-height:1.15;font-family:inherit}input[type=search]{-webkit-appearance:none}:focus{outline:var(--outline-color) solid var(--outline-size);outline-offset:calc(-1*var(--outline-size))}:host([data-js-focus-visible]) :focus:not([data-focus-visible-added]){outline:0}:focus:not(:focus-visible){outline:0}.hide-focus{outline:0}*{box-sizing:border-box}.picker{contain:content;display:flex;flex-direction:column;background:var(--background);border:var(--border-size) solid var(--border-color);border-radius:var(--border-radius);width:100%;height:100%;overflow:hidden;--total-emoji-size:calc(var(--emoji-size) + (2 * var(--emoji-padding)));--total-category-emoji-size:calc(var(--category-emoji-size) + (2 * var(--category-emoji-padding)))}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.hidden{opacity:0;pointer-events:none}.abs-pos{position:absolute;left:0;top:0}.gone{display:none!important}.skintone-button-wrapper,.skintone-list{background:var(--background);z-index:3}.skintone-button-wrapper.expanded{z-index:1}.skintone-list{position:absolute;inset-inline-end:0;top:0;z-index:2;overflow:visible;border-bottom:var(--border-size) solid var(--border-color);border-radius:0 0 var(--skintone-border-radius) var(--skintone-border-radius);will-change:transform;transition:transform .2s ease-in-out;transform-origin:center 0}@media (prefers-reduced-motion:reduce){.skintone-list{transition-duration:.001s}}@supports not (inset-inline-end:0){.skintone-list{right:0}}.skintone-list.no-animate{transition:none}.tabpanel{overflow-y:auto;scrollbar-gutter:stable;-webkit-overflow-scrolling:touch;will-change:transform;min-height:0;flex:1;contain:content}.emoji-menu{display:grid;grid-template-columns:repeat(var(--num-columns),var(--total-emoji-size));justify-content:space-around;align-items:flex-start;width:100%}.emoji-menu.visibility-auto{content-visibility:auto;contain-intrinsic-size:calc(var(--num-columns)*var(--total-emoji-size)) calc(var(--num-rows)*var(--total-emoji-size))}.category{padding:var(--emoji-padding);font-size:var(--category-font-size);color:var(--category-font-color)}.emoji,button.emoji{font-size:var(--emoji-size);display:flex;align-items:center;justify-content:center;border-radius:100%;height:var(--total-emoji-size);width:var(--total-emoji-size);line-height:1;overflow:hidden;font-family:var(--emoji-font-family);cursor:pointer}@media (hover:hover) and (pointer:fine){.emoji:hover,button.emoji:hover{background:var(--button-hover-background)}}.emoji.active,.emoji:active,button.emoji.active,button.emoji:active{background:var(--button-active-background)}.onscreen .custom-emoji::after{content:\"\";width:var(--emoji-size);height:var(--emoji-size);background-repeat:no-repeat;background-position:center center;background-size:contain;background-image:var(--custom-emoji-background)}.nav,.nav-button{align-items:center}.nav{display:grid;justify-content:space-between;contain:content}.nav-button{display:flex;justify-content:center}.nav-emoji{font-size:var(--category-emoji-size);width:var(--total-category-emoji-size);height:var(--total-category-emoji-size)}.indicator-wrapper{display:flex;border-bottom:1px solid var(--border-color)}.indicator{width:calc(100%/var(--num-groups));height:var(--indicator-height);opacity:var(--indicator-opacity);background-color:var(--indicator-color);will-change:transform,opacity;transition:opacity .1s linear,transform .25s ease-in-out}@media (prefers-reduced-motion:reduce){.indicator{will-change:opacity;transition:opacity .1s linear}}.pad-top,input.search{background:var(--background);width:100%}.pad-top{height:var(--emoji-padding);z-index:3}.search-row{display:flex;align-items:center;position:relative;padding-inline-start:var(--emoji-padding);padding-bottom:var(--emoji-padding)}.search-wrapper{flex:1;min-width:0}input.search{padding:var(--input-padding);border-radius:var(--input-border-radius);border:var(--input-border-size) solid var(--input-border-color);color:var(--input-font-color);font-size:var(--input-font-size);line-height:var(--input-line-height)}input.search::placeholder{color:var(--input-placeholder-color)}.favorites{overflow-y:auto;scrollbar-gutter:stable;display:flex;flex-direction:row;border-top:var(--border-size) solid var(--border-color);contain:content}.message{padding:var(--emoji-padding)}";
var PROPS = ['customEmoji', 'customCategorySorting', 'database', 'dataSource', 'i18n', 'locale', 'skinToneEmoji', 'emojiVersion'];

// Styles injected ourselves, so we can declare the FONT_FAMILY variable in one place
var EXTRA_STYLES = ":host{--emoji-font-family:".concat(FONT_FAMILY, "}");
var PickerElement = exports.default = /*#__PURE__*/function (_HTMLElement) {
  function PickerElement(props) {
    var _this;
    _classCallCheck(this, PickerElement);
    _this = _callSuper(this, PickerElement);
    _this.attachShadow({
      mode: 'open'
    });
    var style = document.createElement('style');
    style.textContent = baseStyles + EXTRA_STYLES;
    _this.shadowRoot.appendChild(style);
    _this._ctx = _objectSpread({
      // Set defaults
      locale: DEFAULT_LOCALE,
      dataSource: DEFAULT_DATA_SOURCE,
      skinToneEmoji: DEFAULT_SKIN_TONE_EMOJI,
      customCategorySorting: DEFAULT_CATEGORY_SORTING,
      customEmoji: null,
      i18n: enI18n,
      emojiVersion: null
    }, props);
    // Handle properties set before the element was upgraded
    var _iterator0 = _createForOfIteratorHelper(PROPS),
      _step0;
    try {
      for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
        var prop = _step0.value;
        if (prop !== 'database' && Object.prototype.hasOwnProperty.call(_this, prop)) {
          _this._ctx[prop] = _this[prop];
          delete _this[prop];
        }
      }
    } catch (err) {
      _iterator0.e(err);
    } finally {
      _iterator0.f();
    }
    _this._dbFlush(); // wait for a flush before creating the db, in case the user calls e.g. a setter or setAttribute
    return _this;
  }
  _inherits(PickerElement, _HTMLElement);
  return _createClass(PickerElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      // The _cmp may be defined if the component was immediately disconnected and then reconnected. In that case,
      // do nothing (preserve the state)
      if (!this._cmp) {
        this._cmp = createRoot(this.shadowRoot, this._ctx);
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this2 = this;
      // Check in a microtask if the element is still connected. If so, treat this as a "move" rather than a disconnect
      // Inspired by Vue: https://vuejs.org/guide/extras/web-components.html#building-custom-elements-with-vue
      qM(function () {
        // this._cmp may be defined if connect-disconnect-connect-disconnect occurs synchronously
        if (!_this2.isConnected && _this2._cmp) {
          _this2._cmp.$destroy();
          _this2._cmp = undefined;
          var database = _this2._ctx.database;
          database.close()
          // only happens if the database failed to load in the first place, so we don't care
          .catch(function (err) {
            return console.error(err);
          });
        }
      });
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      this._set(
      // convert from kebab-case to camelcase
      // see https://github.com/sveltejs/svelte/issues/3852#issuecomment-665037015
      attrName.replace(/-([a-z])/g, function (_, up) {
        return up.toUpperCase();
      }),
      // convert string attribute to float if necessary
      attrName === 'emoji-version' ? parseFloat(newValue) : newValue);
    }
  }, {
    key: "_set",
    value: function _set(prop, newValue) {
      this._ctx[prop] = newValue;
      if (this._cmp) {
        this._cmp.$set(_defineProperty({}, prop, newValue));
      }
      if (['locale', 'dataSource'].includes(prop)) {
        this._dbFlush();
      }
    }
  }, {
    key: "_dbCreate",
    value: function _dbCreate() {
      var _this$_ctx = this._ctx,
        locale = _this$_ctx.locale,
        dataSource = _this$_ctx.dataSource,
        database = _this$_ctx.database;
      // only create a new database if we really need to
      if (!database || database.locale !== locale || database.dataSource !== dataSource) {
        this._set('database', new _database.default({
          locale: locale,
          dataSource: dataSource
        }));
      }
    }

    // Update the Database in one microtask if the locale/dataSource change. We do one microtask
    // so we don't create two Databases if e.g. both the locale and the dataSource change
  }, {
    key: "_dbFlush",
    value: function _dbFlush() {
      var _this3 = this;
      qM(function () {
        return _this3._dbCreate();
      });
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['locale', 'data-source', 'skin-tone-emoji', 'emoji-version']; // complex objects aren't supported, also use kebab-case
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
var definitions = {};
var _loop2 = function _loop2() {
  var prop = _PROPS[_i3];
  definitions[prop] = {
    get: function get() {
      if (prop === 'database') {
        // in rare cases, the microtask may not be flushed yet, so we need to instantiate the DB
        // now if the user is asking for it
        this._dbCreate();
      }
      return this._ctx[prop];
    },
    set: function set(val) {
      if (prop === 'database') {
        throw new Error('database is read-only');
      }
      this._set(prop, val);
    }
  };
};
for (var _i3 = 0, _PROPS = PROPS; _i3 < _PROPS.length; _i3++) {
  _loop2();
}
Object.defineProperties(PickerElement.prototype, definitions);

/* istanbul ignore else */
if (!customElements.get('emoji-picker')) {
  // if already defined, do nothing (e.g. same script imported twice)
  customElements.define('emoji-picker', PickerElement);
}